module.exports = __webpack_public_path__ + "img/boomplay.fb107ea9.jpg";